/**
 * @package
 * @author Vladimir Stadnik <vladimir.stadnik@cimpleo.com>
 * @class EditCompanyData
 */

export class EditCompanyData {
  public id!: number;
  public name!: string;
  public email!: string;
  public resourceIds?: number[] = [];
}
